package com.eladfinish.bible.contest.screens.browse.contentOfChapter

import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.analytics.providers.AnalyticsProvider
import com.eladfinish.bible.contest.arch.ViewModelStore
import com.eladfinish.bible.contest.chapter_save
import com.eladfinish.bible.contest.choose_aliyah
import com.eladfinish.bible.contest.chumash_parashat_format
import com.eladfinish.bible.contest.common.gender.getHebrewGender
import com.eladfinish.bible.contest.common.gender.personalizeGender
import com.eladfinish.bible.contest.common.usecases.GetBookAndChapterPrefixedByPerekUseCase
import com.eladfinish.bible.contest.common.usecases.RemoveNikudAndTeamimAndMakafUseCase
import com.eladfinish.bible.contest.constants.BooleanConstants
import com.eladfinish.bible.contest.constants.Constants
import com.eladfinish.bible.contest.constants.Constants.PREF_FONT_STAM
import com.eladfinish.bible.contest.constants.NUMBER_OF_BOOKS
import com.eladfinish.bible.contest.constants.NUMBER_OF_CHUMASHIM
import com.eladfinish.bible.contest.constants.SharedPrefsConstants.KEY_REMOVE_VERSE_LETTER
import com.eladfinish.bible.contest.constants.StringConstants.COLON_SPLITTER
import com.eladfinish.bible.contest.copy_options
import com.eladfinish.bible.contest.data.ChapterData
import com.eladfinish.bible.contest.data.SederData
import com.eladfinish.bible.contest.data.common.DocumentTextType
import com.eladfinish.bible.contest.di.config.DebugInfo
import com.eladfinish.bible.contest.domain.BooksRepository
import com.eladfinish.bible.contest.double_format
import com.eladfinish.bible.contest.entities.Parashot
import com.eladfinish.bible.contest.extensions.normalize1To
import com.eladfinish.bible.contest.extensions.putAllWithLog
import com.eladfinish.bible.contest.extensions.runIf
import com.eladfinish.bible.contest.features.copyOptions.model.CopyOptionsOperation
import com.eladfinish.bible.contest.file_was_not_saved
import com.eladfinish.bible.contest.navigation.LexicographicalSortScreenNavigationDestination
import com.eladfinish.bible.contest.navigation.NavigationCommand
import com.eladfinish.bible.contest.navigation.SearchScreenNavigationDestination
import com.eladfinish.bible.contest.perek_str_placeholder
import com.eladfinish.bible.contest.platform.dispatchers.IoDispatcher
import com.eladfinish.bible.contest.screens.browse.contentOfChapter.BrowseChaptersEffect.OpenContent
import com.eladfinish.bible.contest.screens.browse.contentOfChapter.BrowseChaptersState.PartTabSpec
import com.eladfinish.bible.contest.screens.browse.contentOfChapter.BrowseChaptersState.PartUiState
import com.eladfinish.bible.contest.screens.browse.contentOfChapter.model.ContentMode
import com.eladfinish.bible.contest.screens.browse.contentOfChapter.model.OutputConfig
import com.eladfinish.bible.contest.screens.browse.tableOfContents.BrowseColumnsStore.Companion.SEEK_BAR_PROGRESS_TEXT_SIZE
import com.eladfinish.bible.contest.screens.browse.tableOfContents.BrowseColumnsStore.Companion.TEXT_SIZE
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.BrowseMode
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.CompleteType
import com.eladfinish.bible.contest.screens.browse.tableOfContents.model.ShonotEntry
import com.eladfinish.bible.contest.screens.browse.tableOfContents.ui.dialogs.DEFAULT_FONT_SIZE_SP
import com.eladfinish.bible.contest.screens.browse.usecases.BuildPartReadyStateUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.FetchChapterDataUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetTikunKorimFormatUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.ParseSedarimUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.SaveChapterFileUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.chumash.GetContentForChumashModeUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.chumash.GetShmotUseCase
import com.eladfinish.bible.contest.screens.chapterComplete.usecases.ChapterCompleteUseCaseProvider
import com.eladfinish.bible.contest.text.ClickAction
import com.eladfinish.bible.contest.ui.common.FONT_STAM_ASHKENAZ
import com.eladfinish.bible.contest.ui.menus.actions.ChapterContentToolbarAction
import com.eladfinish.bible.contest.ui.models.ChapterTextAlign
import com.eladfinish.bible.contest.utils.GetParashotUseCase
import com.eladfinish.bible.contest.utils.MyStringUtils.addParenthesisOnOtiotPasuk
import com.eladfinish.bible.contest.utils.MyStringUtils.isFromSifreyEmet
import com.eladfinish.bible.contest.utils.addGershaim
import com.eladfinish.bible.contest.utils.toOtiot
import com.russhwolf.settings.Settings
import dev.icerock.moko.resources.desc.StringDesc
import dev.icerock.moko.resources.desc.desc
import dev.icerock.moko.resources.format
import io.github.aakira.napier.Napier
import kotlinx.collections.immutable.persistentListOf
import kotlinx.collections.immutable.toImmutableList
import kotlinx.collections.immutable.toImmutableMap
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.withContext

class BrowseChaptersStore(
    private val browseChaptersStoreParams: BrowseChaptersStoreParams,
    private val debugInfo: DebugInfo,
    private val getContentForChumashModeUseCase: GetContentForChumashModeUseCase,
    private val buildPartReadyStateUseCase: BuildPartReadyStateUseCase,
    private val fetchChapterDataUseCase: FetchChapterDataUseCase,
    private val getParashotUseCase: GetParashotUseCase,
    private val parseSedarimUseCase: ParseSedarimUseCase,
    private val getTikunKorimFormatUseCase: GetTikunKorimFormatUseCase,
    private val getShmotUseCase: GetShmotUseCase,
    private val removeNikudAndTeamimAndMakafUseCase: RemoveNikudAndTeamimAndMakafUseCase,
    private val getBookAndChapterPrefixedByPerekUseCase: GetBookAndChapterPrefixedByPerekUseCase,
    private val saveChapterFileUseCase: SaveChapterFileUseCase,
    private val chapterCompleteUseCaseProvider: ChapterCompleteUseCaseProvider,
    private val analyticsProvider: AnalyticsProvider,
    private val settings: Settings,
) : ViewModelStore<BrowseChaptersState, BrowseChaptersAction, BrowseChaptersEffect>(
    tag = "BrowseTabsStore",
) {

    companion object {
        data class BrowseChaptersStoreParams(
            val browseMode: BrowseMode,
            val isCompleteChapter: Boolean,
            val bookIndex: Int,
            val partIndex: Int,
            val bookmarkScrollY: Int,
            val bookmarkTextOffset: Int = -1,
            val completionDetails: String?,
            val showOnqelos: Boolean,
        )

        const val CHAPTERS_FOLDER = "פרקים"
    }

    private var isSwitchingBook: Boolean = false

    private val browseMode = browseChaptersStoreParams.browseMode
    private val initialBookIndex = browseChaptersStoreParams.bookIndex
    private val initialBookmarkPartIndex: Int = browseChaptersStoreParams.partIndex
    private val initialBookmarkScrollY = browseChaptersStoreParams.bookmarkScrollY
    private val completionDetails = browseChaptersStoreParams.completionDetails

    private var pendingInitialBookmarkScrollY: Int? = initialBookmarkScrollY.takeIf { it > 0 }
    private var didEmitInitialBookmarkScroll: Boolean = false

    private var cachedParashot: Parashot? = null
    private var cachedSedarim: List<SederData>? = null

    /** The name Tehilim 119 of the "שונות" tab spells, once entered. */
    private var deceasedName: String? = null
    private val loggedShonotEntries = mutableSetOf<ShonotEntry>()

    private val textSize: Float
        get() = settings.getFloat(
            key = Constants.PREF_CHAPTER_CONTENT_FONT_SIZE,
            defaultValue = SEEK_BAR_PROGRESS_TEXT_SIZE + TEXT_SIZE,
        )

    private val removeVerseLetter by lazy {
        settings.getBoolean(
            key = KEY_REMOVE_VERSE_LETTER,
            defaultValue = false,
        )
    }

    override val stateFlow = MutableStateFlow(initialState())

    private fun initialState(): BrowseChaptersState {
        val books = browseMode.items()
        val totalBooks = books.size
        val bookIndex = initialBookIndex
        val prevIndex = prevBookIndex(bookIndex, totalBooks)
        val nextIndex = nextBookIndex(bookIndex, totalBooks)
        val tabs = buildTabs(bookIndex = bookIndex).toImmutableList()
        val numberOfParts = calculateNumberOfParts(bookIndex) // depends on the execution of buildTabs

        return BrowseChaptersState(
            isCompleteChapter = browseChaptersStoreParams.isCompleteChapter,
            isDebugMode = debugInfo.isDebugMode,
            textSize = textSize,
            numberOfParts = numberOfParts,
            currentBook = bookIndex,
            currentPart = initialBookmarkPartIndex,
            bookName = books[bookIndex - 1],
            previousBookName = books[prevIndex - 1],
            nextBookName = books[nextIndex - 1],
            tabs = tabs,
            parts = emptyMap<Int, PartUiState>().toImmutableMap(),
            // Opened on Tehilim 119: asks for the name at once, as its button in the list did.
            dialogState = if (shonotEntryOrNull(initialBookmarkPartIndex) == ShonotEntry.TEHILIM119) {
                BrowseChaptersState.DialogState.DeceasedName()
            } else {
                BrowseChaptersState.DialogState.None
            },
            isLoading = false,
            deceasedNamePage = if (browseMode == BrowseMode.SHONOT_MODE) ShonotEntry.TEHILIM119.ordinal else null,
        )
    }

    /** The entry of the "שונות" tab at [partIndex] (its tab, 0-based), or null in the other modes. */
    private fun shonotEntryOrNull(partIndex: Int): ShonotEntry? =
        if (browseMode == BrowseMode.SHONOT_MODE) ShonotEntry.entries.getOrNull(partIndex) else null

    /** The pages of the parts: after the previous book's page when there are books, from 0 when not. */
    private val partPages: IntRange
        get() = if (browseMode.hasBooks) 1..currentState.numberOfParts else 0 until currentState.numberOfParts

    private fun buildTabs(bookIndex: Int): List<PartTabSpec> {
        return buildList {
            if (browseMode.hasBooks) add(PartTabSpec.ArrowRight)
            when (browseMode) {
                BrowseMode.BIBLE_MODE -> {
                    buildBibleTabs(numberOfChapters = BooksRepository.numOfChaptersPerBook[bookIndex - 1])
                }

                BrowseMode.CHUMASH_MODE -> {
                    buildChumashTabs(bookIndex.normalize1To(max = NUMBER_OF_CHUMASHIM))
                }

                BrowseMode.SEDARIM_MODE -> {
                    buildSedarimTabs(bookIndex)
                }

                BrowseMode.SHONOT_MODE -> {
                    ShonotEntry.entries.map { PartTabSpec.Part(stringDesc = it.title.desc()) }
                }
            }.let {
                addAll(it)
            }
            if (browseMode.hasBooks) add(PartTabSpec.ArrowLeft)
        }
    }

    private fun buildBibleTabs(numberOfChapters: Int): List<PartTabSpec> {
        cachedParashot = null
        cachedSedarim = null
        return (1..numberOfChapters).map { chapter ->
            PartTabSpec.Part(
                stringDesc = SharedRes.strings.perek_str_placeholder.format(
                    chapter.toOtiot().addGershaim()
                )
            )
        }
    }

    private fun buildChumashTabs(bookIndex: Int): List<PartTabSpec> {
        cachedSedarim = null
        return getParashotUseCase.parseParashot(bookNumber = bookIndex, connected = true)
            .also {
                cachedParashot = it
            }
            .parashotNames
            .map {
                PartTabSpec.Part(stringDesc = it.desc())
            }
    }

    private fun buildSedarimTabs(bookIndex: Int): List<PartTabSpec> {
        cachedParashot = null
        return parseSedarimUseCase(bookNumber = bookIndex - 1)
            .also {
                cachedSedarim = it
            }
            .map {
                PartTabSpec.Part(stringDesc = it.name)
            }
    }

    override fun handleAction(action: BrowseChaptersAction): BrowseChaptersState =
        when (action) {
            is BrowseChaptersAction.PartSettled -> {
                if (action.bookIndex != currentState.currentBook) currentState

                // Update currentChapter so UI <-> Store stay in sync
                updateState { it.copy(currentPart = action.partIndex) }
                logShonotEntryShown(partIndex = action.partIndex)
                currentState
            }

            is BrowseChaptersAction.PageVisible -> {
                if (action.bookIndex != currentState.currentBook) currentState

                // Fire-and-forget load in background
                loadPartAndPrefetchIfNeeded(action.partIndex)
                currentState
            }

            BrowseChaptersAction.NavigateToPreviousBook -> {
                switchBook(isNext = false)
            }

            BrowseChaptersAction.NavigateToNextBook -> {
                switchBook(isNext = true)
            }

            is BrowseChaptersAction.ToolbarClicked -> {
                handleToolbarClicked(action.toolbarAction)
            }

            BrowseChaptersAction.HideDialog -> {
                handleHideDialog()
            }

            BrowseChaptersAction.EnterDeceasedNameClicked -> {
                currentState.copy(
                    dialogState = BrowseChaptersState.DialogState.DeceasedName(currentName = deceasedName.orEmpty()),
                )
            }

            is BrowseChaptersAction.DeceasedNameConfirmed -> {
                handleDeceasedNameConfirmed(name = action.name)
            }

            is BrowseChaptersAction.UpdateFontSize -> {
                handleUpdateFontSize(value = action.value)
            }

            is BrowseChaptersAction.AliyahClicked -> {
                handleAliyahClicked(aliyahLabel = action.aliyahLabel)
            }

            is BrowseChaptersAction.CopySelectedText -> {
                handleCopySelectedText(rawSelectedText = action.rawSelectedText)
            }

            is BrowseChaptersAction.ClipboardTextCopied -> {
                handleClipboardTextCopied(rawSelectedText = action.rawText)
            }

            is BrowseChaptersAction.SearchSelectedText -> {
                handleSearchSelectedText(rawSelectedText = action.rawSelectedText)
            }

            is BrowseChaptersAction.SaveFile -> {
                handleSaveFile(
                    bookAndChapter = action.bookAndChapterForExport,
                    content = action.content,
                    documentTextType = action.documentTextType,
                )
            }

            // chapter complete
            is BrowseChaptersAction.ExposureTypesClicked -> {
                handleExposureTypesClicked(action.completeType)
            }

            is BrowseChaptersAction.ChapterCompleteClick -> {
                handleChapterCompleteClick(action.clickAction)
            }

            BrowseChaptersAction.ConsumeScrollEvent -> {
                handleConsumeScrollEvent()
            }
        }

    private fun handleToolbarClicked(toolbarAction: ChapterContentToolbarAction): BrowseChaptersState {
        return when (toolbarAction) {
            ChapterContentToolbarAction.ChangeFontSize -> {
                handleChangeFontSizeClicked()
            }

            is ChapterContentToolbarAction.AddBookmark -> {
                handleAddBookmark(scrollY = toolbarAction.scrollY, textOffset = toolbarAction.textOffset)
            }

            ChapterContentToolbarAction.ChooseAliyah -> {
                handleChooseAliyah()
            }

            ChapterContentToolbarAction.ShowOnqelos -> {
                handleShowOnqelos()
            }

            ChapterContentToolbarAction.TikunKorim -> {
                handleTikunKorim()
            }

            ChapterContentToolbarAction.SaveContent -> {
                handleSaveContent()
            }
        }
    }

    /** Once per entry of the "שונות" tab and screen, under the event its button in the list sent. */
    private fun logShonotEntryShown(partIndex: Int) {
        val entry = shonotEntryOrNull(partIndex) ?: return
        // Tehilim 119 is logged with the name, when it is entered.
        if (entry == ShonotEntry.TEHILIM119) return
        if (loggedShonotEntries.add(entry)) analyticsProvider.logEvent(event = entry.name)
    }

    private fun handleDeceasedNameConfirmed(name: String): BrowseChaptersState {
        if (name == deceasedName) return currentState.copy(dialogState = BrowseChaptersState.DialogState.None)
        analyticsProvider.logEvent(event = ShonotEntry.TEHILIM119.name, params = mapOf("שם" to name))
        deceasedName = name
        updateState { it.copy(dialogState = BrowseChaptersState.DialogState.None) }
        // A new name replaces the verses of the previous one.
        val partIndex = ShonotEntry.TEHILIM119.ordinal
        updateState { it.copy(parts = (it.parts - partIndex).toImmutableMap()) }
        loadPartIfNeeded(partIndex = partIndex)
        return currentState
    }

    private fun handleShowOnqelos(): BrowseChaptersState {
        analyticsProvider.logEvent(event = "שניים מקרא ואחד תרגום")

        val bookIndex = currentState.currentBook
        val partIndex = currentState.currentPart
        val parashaDesc = (currentState.tabs[partIndex] as PartTabSpec.Part).stringDesc
        val parashot = cachedParashot ?: return currentState

        updateState { state ->
            state.copy(
                parts = state.parts
                    .plus(partIndex to PartUiState.Loading)
                    .toImmutableMap(),
            )
        }

        launchEffect {
            val result = getShmotUseCase(
                bookIndex = bookIndex,
                partIndex = partIndex,
                parashaNameDesc = parashaDesc,
                cachedParashot = parashot,
            )

            updateState { state ->
                state.copy(
                    parts = state.parts
                        .plus(
                            pair = partIndex to PartUiState.Ready(
                                chapterData = ChapterData(
                                    content = result.charSequence.toString(),
                                    spannedRangeList = result.spannedRangeList,
                                ),
                            )
                        )
                        .toImmutableMap(),
                )
            }
        }

        return currentState
    }

    private fun handleTikunKorim(): BrowseChaptersState {
        analyticsProvider.logEvent(event = "תיקון קוראים")
        val content = getContentForChumashModeUseCase(
            bookIndex = currentState.currentBook,
            partIndex = currentState.currentPart,
            cachedParashot = cachedParashot!!,
            isTikunKorim = true,
        ).content
        return currentState.updateActiveChapter { partUiStateReady ->
            val formattedText = getTikunKorimFormatUseCase(originalText = content)
            partUiStateReady.copy(
                chapterData = partUiStateReady.chapterData.copy(
                    content = formattedText,
                    spannedRangeList = persistentListOf(),
                ),
                stamFont = settings.getString(key = PREF_FONT_STAM, defaultValue = FONT_STAM_ASHKENAZ),
            )
        }
    }

    private inline fun BrowseChaptersState.updateActiveChapter(
        transform: (PartUiState.Ready) -> PartUiState.Ready,
    ): BrowseChaptersState {
        val key = currentPart
        val uiState = parts[key] as? PartUiState.Ready ?: return this

        val updated = transform(uiState)

        return copy(
            parts = (parts + (key to updated)).toImmutableMap(),
        )
    }

    private fun handleChooseAliyah(): BrowseChaptersState {
        return currentState.copy(
            dialogState = BrowseChaptersState.DialogState.ChooseAliyah(
                title = SharedRes.strings.choose_aliyah.desc().personalizeGender(hebrewGender = settings.getHebrewGender())
            )
        )
    }

    private fun handleAddBookmark(scrollY: Int, textOffset: Int): BrowseChaptersState {
        analyticsProvider.logEvent(event = "הוספת סימניה")
        settings.putAllWithLog(
            values = mapOf(
                Constants.PREF_BOOKMARK_BROWSE_MODE to browseMode.name,
                Constants.PREF_BOOKMARK_BOOK to currentState.currentBook - 1,
                Constants.PREF_BOOKMARK_CHAPTER to currentState.currentPart - 1,
                Constants.PREF_BOOKMARK_SCROLL_Y to scrollY,
                Constants.PREF_BOOKMARK_TEXT_OFFSET to textOffset,
                Constants.PREF_BOOKMARK_ONQELOS to false,
            ),
            logTag = "Bookmark",
        )
        launchEffect {
            sideEffectFlow.emit(BrowseChaptersEffect.NotifyBookmarkSaved)
        }
        return currentState
    }

    private fun handleChangeFontSizeClicked(): BrowseChaptersState {
        val currentFontSize = settings.getFloat(
            key = Constants.PREF_CHAPTER_CONTENT_FONT_SIZE,
            defaultValue = DEFAULT_FONT_SIZE_SP,
        )
        return currentState.copy(dialogState = BrowseChaptersState.DialogState.FontSize(currentFontSize = currentFontSize))
    }

    private fun handleHideDialog(): BrowseChaptersState {
        return currentState.copy(dialogState = BrowseChaptersState.DialogState.None)
    }

    /**
     * User requested the standalone lexicographical sort screen, pre-filled
     * with the book/chapter currently being browsed.
     */
    private fun handleLexicographicalSortClicked(): BrowseChaptersState {
        return onlyEffect(
            OpenContent(
                navigation = LexicographicalSortScreenNavigationDestination(
                    bookIndex = currentState.currentBook,
                    chapterIndex = currentState.currentPart,
                ).let(NavigationCommand::Navigate)
            )
        )
    }

    private fun handleUpdateFontSize(value: Float): BrowseChaptersState {
        settings.putFloat(
            key = Constants.PREF_CHAPTER_CONTENT_FONT_SIZE,
            value = value,
        )
        return currentState.copy(textSize = value)
    }

    private fun handleAliyahClicked(aliyahLabel: String): BrowseChaptersState {
        return onlyEffect(BrowseChaptersEffect.ScrollToAliyah(aliyahLabel))
    }

    private fun loadPartAndPrefetchIfNeeded(partIndex: Int) {
        // Load current + prefetch neighbors for smoother UX
        val targets = listOf(partIndex, partIndex - 1, partIndex + 1)
            .filter { it in partPages }

        targets.forEach { index ->
            loadPartIfNeeded(partIndex = index)
        }
    }

    // --- Keep your existing fields, plus this helper if you want ---
    private fun BrowseChaptersStore.isSameBookSnapshot(
        bookIndexSnapshot: Int,
    ): Boolean {
        return currentState.currentBook == bookIndexSnapshot
    }

    // --- New refactored loadPartIfNeeded ---
    private fun BrowseChaptersStore.loadPartIfNeeded(
        partIndex: Int,
    ) {
        val existing = currentState.parts[partIndex]

        if (existing is PartUiState.Ready) {
            val bookIndexSnapshot = currentState.currentBook
            launchEffect {
                maybeEmitInitialBookmarkScroll(
                    partIndex = partIndex,
                    bookIndexSnapshot = bookIndexSnapshot,
                )
            }
            return
        }

        if (existing is PartUiState.Loading) return

        if (shonotEntryOrNull(partIndex) == ShonotEntry.TEHILIM119 && deceasedName == null) {
            updateState {
                it.copy(
                    parts = (it.parts + (partIndex to PartUiState.AwaitingDeceasedName)).toImmutableMap(),
                )
            }
            return
        }

        updateState {
            it.copy(
                parts = (it.parts + (partIndex to PartUiState.Loading)).toImmutableMap(),
            )
        }

        val bookIndexSnapshot = currentState.currentBook

        launchEffect {
            withContext(IoDispatcher) {
                runCatching {
                    fetchChapterDataUseCase(
                        browseMode = browseMode,
                        bookIndex = currentState.currentBook,
                        partIndex = partIndex,
                        cachedParashot = cachedParashot,
                        deceasedName = deceasedName,
                    )
                }.onSuccess { chapterData ->
                    if (!isSameBookSnapshot(bookIndexSnapshot)) return@onSuccess

                    val hebrewBookName = BooksRepository.bookNamesHebrew[currentState.currentBook - 1]

                    // The "שונות" texts come laid out (Tehilim 119 in columns) and are not completed.
                    val ready = if (browseMode == BrowseMode.SHONOT_MODE) {
                        PartUiState.Ready(chapterData = chapterData)
                    } else {
                        buildPartReadyStateUseCase(
                            params = BuildPartReadyStateUseCase.Params(
                                isCompleteChapter = browseChaptersStoreParams.isCompleteChapter,
                                currentBook = currentState.currentBook,
                                partIndex = partIndex,
                                hebrewBookName = hebrewBookName,
                                chapterData = chapterData,
                                completionDetails = completionDetails,
                            ),
                        )
                    }

                    updateState { state ->
                        state.copy(
                            parts = (state.parts + (partIndex to ready)).toImmutableMap(),
                        )
                    }

                    maybeEmitInitialBookmarkScroll(
                        partIndex = partIndex,
                        bookIndexSnapshot = bookIndexSnapshot,
                    )
                }.onFailure { t ->
                    if (!isSameBookSnapshot(bookIndexSnapshot)) return@onFailure

                    updateState { state ->
                        state.copy(
                            parts = (state.parts + (partIndex to PartUiState.Error(
                                message = t.message ?: "Load failed",
                            ))).toImmutableMap(),
                        )
                    }
                }
            }
        }
    }

    private suspend fun maybeEmitInitialBookmarkScroll(
        partIndex: Int,
        bookIndexSnapshot: Int,
    ) {
        if (didEmitInitialBookmarkScroll) return
        if (currentState.currentBook != bookIndexSnapshot) return
        if (partIndex != initialBookmarkPartIndex) return

        val y = pendingInitialBookmarkScrollY ?: return
        didEmitInitialBookmarkScroll = true
        pendingInitialBookmarkScrollY = null

        sideEffectFlow.emit(
            BrowseChaptersEffect.ScrollToPosition(yOffest = y, textOffset = browseChaptersStoreParams.bookmarkTextOffset)
        )
    }

    private fun prevBookIndex(currentBook1Based: Int, totalBooks: Int): Int {
        return if (currentBook1Based == 1) totalBooks else currentBook1Based - 1
    }

    private fun nextBookIndex(currentBook1Based: Int, totalBooks: Int): Int {
        return if (currentBook1Based == totalBooks) 1 else currentBook1Based + 1
    }

    private fun switchBook(isNext: Boolean): BrowseChaptersState {
        if (isSwitchingBook) return currentState
        isSwitchingBook = true

        return try {
            val totalBooks = when (browseMode) {
                BrowseMode.BIBLE_MODE -> NUMBER_OF_BOOKS
                BrowseMode.CHUMASH_MODE -> NUMBER_OF_CHUMASHIM
                BrowseMode.SEDARIM_MODE -> NUMBER_OF_BOOKS
                BrowseMode.SHONOT_MODE -> 1
            }

            val currentBookIndex = currentState.currentBook // 1-based

            val newBookIndex = if (isNext) {
                if (currentBookIndex == totalBooks) 1 else currentBookIndex + 1
            } else {
                if (currentBookIndex == 1) totalBooks else currentBookIndex - 1
            }

            val tabs = buildTabs(bookIndex = newBookIndex).toImmutableList()
            val newNumberOfParts = calculateNumberOfParts(newBookIndex) // depends on the execution of buildTabs
            val prevBook = if (newBookIndex == 1) totalBooks else newBookIndex - 1
            val nextBook = if (newBookIndex == totalBooks) 1 else newBookIndex + 1

            // יעד אחרי החלפת ספר:
            // next -> פרק 1 (page=1)
            // prev -> פרק אחרון (page=newNumberOfChapters)
            val targetPage = if (isNext) 1 else newNumberOfParts

            val books = browseMode.items()
            Napier.d(
                tag = "BrowseChaptersStore",
                message = "Switching book to $newBookIndex [browseMode is $browseMode, size: ${books.size}]"
            )

            currentState.copy(
                currentBook = newBookIndex,
                bookName = books[newBookIndex - 1],
                previousBookName = books[prevBook - 1],
                nextBookName = books[nextBook - 1],
                numberOfParts = newNumberOfParts,
                tabs = tabs,
                parts = emptyMap<Int, PartUiState>().toImmutableMap(),
                currentPart = targetPage, // חשוב: לשמור עקבי עם ה-pager
            )
        } finally {
            isSwitchingBook = false
        }
    }

    private fun calculateNumberOfParts(bookIndex: Int): Int {
        return when (browseMode) {
            BrowseMode.BIBLE_MODE,
            BrowseMode.CHUMASH_MODE,
                -> BooksRepository.numOfChaptersPerBook[bookIndex - 1]

            BrowseMode.SEDARIM_MODE -> cachedSedarim?.size ?: 0

            BrowseMode.SHONOT_MODE -> ShonotEntry.entries.size
        }
    }

    private fun handleSaveContent(): BrowseChaptersState {
        val (text, shouldAddParenthesisOnOtiotPasuk, shouldIncludeOnlyBookNameInFileName, documentTextType) = currentTextForCopyOrSave()
        return currentState.copy(
            dialogState = BrowseChaptersState.DialogState.BrowseCopyOptions(
                operation = CopyOptionsOperation.SAVE_FILE,
                title = SharedRes.strings.chapter_save,
                text = text.runIf(condition = shouldAddParenthesisOnOtiotPasuk) {
                    addParenthesisOnOtiotPasuk(input = this)
                },
                bookAndChapterForExport = getBookAndChapterForExport(shouldIncludeOnlyBookNameInFileName = shouldIncludeOnlyBookNameInFileName),
                shouldAddParenthesisOnOtiotPasuk = shouldAddParenthesisOnOtiotPasuk,
                documentTextType = documentTextType,
            )
        )
    }

    private fun currentPartReadyOrNull(): PartUiState.Ready? {
        return currentState.parts[currentState.currentPart] as? PartUiState.Ready
    }

    private fun currentTextForCopyOrSave(): OutputConfig {
        val ready = currentPartReadyOrNull() ?: return OutputConfig(text = "", shouldAddParenthesisOnOtiotPasuk = true)

        return when (val mode = ready.contentMode) {
            is ContentMode.UserCompletions -> {
                OutputConfig(text = mode.output.charSequence.toString(), shouldAddParenthesisOnOtiotPasuk = true)
            }

            is ContentMode.ChapterComplete -> {
                OutputConfig(text = mode.output.charSequence.toString(), shouldAddParenthesisOnOtiotPasuk = true)
            }

            is ContentMode.SavedCompletion -> {
                OutputConfig(text = mode.output.charSequence.toString(), shouldAddParenthesisOnOtiotPasuk = true)
            }

            is ContentMode.ProgressiveExposure -> {
                OutputConfig(text = mode.state.renderedTextSoFar, shouldAddParenthesisOnOtiotPasuk = true)
            }

            is ContentMode.ShuffledVerses -> {
                // Useful "copy" format: one verse per block, with verse marker.
                OutputConfig(text = mode.verses.joinToString(separator = "\n\n") { verse ->
                    buildString {
                        append(verse.reysha.trim())
                        append("\n")
                        append(verse.seyfa.trim())
                        append(" [פסוק ${verse.otPasuk.addGershaim()}]")
                    }
                }, shouldAddParenthesisOnOtiotPasuk = true)
            }

            ContentMode.Normal -> {
                OutputConfig(text = ready.chapterData.content, shouldAddParenthesisOnOtiotPasuk = true)
            }
        }
    }

    private fun handleClipboardTextCopied(
        rawSelectedText: String,
    ): BrowseChaptersState {
        val copied = rawSelectedText.trim()
        if (copied.isEmpty()) return currentState

        if (currentState.dialogState is BrowseChaptersState.DialogState.BrowseCopyOptions) {
            // Dialog already open -> do nothing
            return currentState
        }

        return handleCopySelectedText(
            rawSelectedText = copied,
        )
    }

    private fun handleCopySelectedText(rawSelectedText: String): BrowseChaptersState {
        return currentState.copy(
            dialogState = BrowseChaptersState.DialogState.BrowseCopyOptions(
                operation = CopyOptionsOperation.COPY_TEXT,
                title = SharedRes.strings.copy_options,
                text = rawSelectedText,
                bookAndChapterForExport = getBookAndChapterForExport(),
                shouldAddParenthesisOnOtiotPasuk = true,
                documentTextType = DocumentTextType.TXT,
            )
        )
    }

    private fun getBookAndChapterForExport(shouldIncludeOnlyBookNameInFileName: Boolean = false): StringDesc {
        val hebrewBookName = BooksRepository.bookNamesHebrew[currentState.currentBook - 1]
        val bookAndChapter: StringDesc
        when (browseMode) {
            BrowseMode.BIBLE_MODE -> {
                bookAndChapter = getBookAndChapterPrefixedByPerekUseCase(
                    book = hebrewBookName,
                    chapter = currentState.currentPart.toOtiot(),
                    onlyBook = shouldIncludeOnlyBookNameInFileName,
                ).desc()
            }

            BrowseMode.CHUMASH_MODE -> {
                val parashaName = cachedParashot?.parashotNames[currentState.currentPart - 1]
                bookAndChapter = SharedRes.strings.chumash_parashat_format.format(hebrewBookName, parashaName.orEmpty())
            }

            BrowseMode.SEDARIM_MODE -> {
                val sederDesc = (currentState.tabs[currentState.currentPart] as PartTabSpec.Part).stringDesc
                val book = BrowseMode.SEDARIM_MODE.items()[currentState.currentBook - 1]
                bookAndChapter = SharedRes.strings.double_format.format(book, sederDesc)
            }

            BrowseMode.SHONOT_MODE -> {
                bookAndChapter = ShonotEntry.entries[currentState.currentPart].title.desc()
            }
        }
        return bookAndChapter
    }

    private fun handleSearchSelectedText(rawSelectedText: String): BrowseChaptersState {
        val indexOfSofPasuk = rawSelectedText.indexOf(COLON_SPLITTER)
        if (indexOfSofPasuk != -1 && indexOfSofPasuk < rawSelectedText.length) {
            return onlyEffect(BrowseChaptersEffect.ShowToast(text = "לא ניתן לחפש טקסט שמתפרשׂ על פני יותר מפסוק אחד"))
        } else {
            val query = removeNikudAndTeamimAndMakafUseCase(pasuk = rawSelectedText)
            return onlyEffect(
                OpenContent(
                    navigation = SearchScreenNavigationDestination(text = query)
                        .let(NavigationCommand::Navigate)
                )
            )
        }
    }

    private fun handleSaveFile(
        bookAndChapter: String,
        content: String,
        documentTextType: DocumentTextType,
    ): BrowseChaptersState {
        launchEffect {
            withContext(IoDispatcher) {
                val success = saveChapterFileUseCase(
                    bookAndChapter = bookAndChapter,
                    content = content,
                    completeChapter = browseChaptersStoreParams.isCompleteChapter,
                    currentBook = currentState.currentBook,
                    currentPart = currentState.currentPart,
                    documentTextType = documentTextType,
                )
                if (success) {
                    sideEffectFlow.emit(BrowseChaptersEffect.ShowToast("הקובץ '$bookAndChapter' נשמר בהצלחה"))
                } else {
                    sideEffectFlow.emit(BrowseChaptersEffect.ShowToast("שגיאה בשמירת הקובץ")) // SharedRes.strings.file_was_not_saved
                }
            }
        }

        return currentState
    }

    private fun handleExposureTypesClicked(completeType: CompleteType): BrowseChaptersState {
        analyticsProvider.logEvent(completeType.name)
        return exposeSegment(completeType = completeType)
    }

    private fun exposeSegment(completeType: CompleteType): BrowseChaptersState {
        if (completeType != CompleteType.SHUFFLE_VERSES && completeType != CompleteType.CREATE_COMPLETIONS) {
            val key = Constants.PREF_SHOW_WITH_TEAMIM
            if (!settings.getBoolean(key = key, defaultValue = BooleanConstants.ENABLE_SHOW_WITH_TEAMIM_PREF)) {
                val text = "יש לבחור בהצגת טעמי המקרא במסך הגדרות"
                onlyEffect(BrowseChaptersEffect.ShowToast(text))
                return currentState
            }
        }

        if (removeVerseLetter && completeType !in listOf(CompleteType.SHUFFLE_VERSES, CompleteType.CREATE_COMPLETIONS)
        ) {
            val text = "מצב הסרת אותיות הפסוקים נתמך לעת עתה רק ביצירת השלמות (הכפתור השמאלי ביותר)."
            onlyEffect(BrowseChaptersEffect.ShowToast(text))
            return currentState
        }

        return executeCompleteType(completeType)
    }

    private fun executeCompleteType(completeType: CompleteType): BrowseChaptersState {
        return when (completeType) {
            CompleteType.PARTIALLY_EXPOSURE,
            CompleteType.REYSHOT_EXPOSURE,
            CompleteType.SEYFOT_EXPOSURE,
                -> {
                applyChapterCompleteType(completeType)
            }

            CompleteType.NEXT_EXPOSURE_VERSE,
            CompleteType.NEXT_EXPOSURE_HALF,
            CompleteType.NEXT_EXPOSURE_WORD,
                -> {
                handleNextExposure(completeType)
            }

            CompleteType.SHUFFLE_VERSES -> {
                handleShuffleVerses()
            }

            CompleteType.CREATE_COMPLETIONS -> {
                handleCreateCompletions()
            }

            CompleteType.LEXICOGRAPHICALLY_SORTING -> {
                handleLexicographicalSortClicked()
            }

            CompleteType.RESET -> {
                handleReset()
            }
        }
    }

    private fun handleConsumeScrollEvent(): BrowseChaptersState {
        val currentPart = currentState.currentPart

        val ready = currentState.parts[currentPart] as? PartUiState.Ready
            ?: return currentState

        if (ready.scrollEvent == ScrollEvent.None) return currentState

        val updatedReady = ready.copy(
            scrollEvent = ScrollEvent.None,
        )

        return currentState.copy(
            parts = currentState.parts
                .plus(
                    currentPart to updatedReady,
                )
                .toImmutableMap(),
        )
    }

    private fun handleReset(): BrowseChaptersState {
        val currentPart = currentState.currentPart

        val ready = currentState.parts[currentPart] as? PartUiState.Ready
            ?: return currentState

        val resetReady = ready.copy(
            contentMode = ContentMode.Normal,
            scrollEvent = ScrollEvent.ToTop,
        )

        return currentState.copy(
            parts = currentState.parts
                .plus(
                    pair = currentPart to resetReady,
                )
                .toImmutableMap(),
            dialogState = BrowseChaptersState.DialogState.None,
        )
    }

    private data class ActivePartContext(
        val partIndex: Int,
        val ready: PartUiState.Ready,
        val chapterData: ChapterData,
        val content: String,
        val partitionedChapter: List<List<List<String>>>,
    )

    private fun activePartContextOrNull(): ActivePartContext? {
        val partIndex = currentState.currentPart
        val ready = currentState.parts[partIndex] as? PartUiState.Ready
            ?: return null

        val chapterData = ready.chapterData
        val content = chapterData.content

        val currentBook = currentState.currentBook
        val partitionedChapter = chapterCompleteUseCaseProvider.partitionChapterUseCase(
            chapter = content,
            isFromSifreyEmet = isFromSifreyEmet(
                bookNameHebrew = BooksRepository.bookNamesHebrew[currentBook - 1],
            ),
        )

        return ActivePartContext(
            partIndex = partIndex,
            ready = ready,
            chapterData = chapterData,
            content = content,
            partitionedChapter = partitionedChapter,
        )
    }

    private fun handleShuffleVerses(): BrowseChaptersState {
        val context = activePartContextOrNull()
            ?: return currentState

        val shuffledVerses = chapterCompleteUseCaseProvider.buildShuffledVersesUseCase(
            partitionedChapter = context.partitionedChapter,
        )

        val updatedReady = context.ready.copy(
            contentMode = ContentMode.ShuffledVerses(
                verses = shuffledVerses,
            ),
        )

        return currentState.copy(
            parts = currentState.parts
                .plus(
                    pair = context.partIndex to updatedReady,
                )
                .toImmutableMap(),
            dialogState = BrowseChaptersState.DialogState.None,
        )
    }

    private fun applyChapterCompleteType(
        completeType: CompleteType,
    ): BrowseChaptersState {
        val context = activePartContextOrNull()
            ?: return currentState

        val spannableStringKMP = chapterCompleteUseCaseProvider.buildContentByExposureTypeDomainUseCase(
            completeType = completeType,
            partitionedChapter = context.partitionedChapter,
        )

        val updatedReady = context.ready.copy(
            contentMode = ContentMode.ChapterComplete(
                type = completeType,
                output = spannableStringKMP,
            ),
            chapterData = context.chapterData.copy(
                content = context.content,
                textAlign = ChapterTextAlign.START,
            ),
        )

        return currentState.copy(
            parts = currentState.parts
                .plus(
                    pair = context.partIndex to updatedReady,
                )
                .toImmutableMap(),
        )
    }

    private fun handleNextExposure(completeType: CompleteType): BrowseChaptersState {
        val ready = currentPartReadyOrNull() ?: return currentState
        val content = ready.chapterData.content

        val out = chapterCompleteUseCaseProvider.verseOrHalfOrWordCompletionUseCase(
            parts = currentState.parts,
            currentPart = currentState.currentPart,
            completeType = completeType,
            chapterText = content,
            isFromSifreyEmet = isFromSifreyEmet(
                bookNameHebrew = BooksRepository.bookNamesHebrew[currentState.currentBook - 1],
            ),
        )

        if (out.reachedEnd) {
            onlyEffect(
                BrowseChaptersEffect.ShowToast("הגעת לסוף הפרק"),
            )
        }

        return currentState.copy(
            parts = out.parts,
        )
    }

    private fun handleChapterCompleteClick(clickAction: ClickAction): BrowseChaptersState {
        return when (clickAction) {
            is ClickAction.RevealBlank -> handleRevealBlank(clickAction)
            is ClickAction.ToggleUserBlank -> handleUserCompletionTokenClicked(clickAction.tokenIndex)
        }
    }

    private fun handleRevealBlank(clickAction: ClickAction.RevealBlank): BrowseChaptersState = currentState.copy(
        parts = chapterCompleteUseCaseProvider.revealBlankUseCase(
            parts = currentState.parts,
            currentPart = currentState.currentPart,
            originWord = clickAction.originWord,
            endsWithMakaf = clickAction.endsWithMakaf,
        )
    )

    private fun handleCreateCompletions(): BrowseChaptersState {
        val ready = currentPartReadyOrNull() ?: return currentState

        // Already in user-completions mode -> do nothing
        if (ready.contentMode is ContentMode.UserCompletions) return currentState

        val content = ready.chapterData.content

        val model = chapterCompleteUseCaseProvider.buildUserCompletionsModelUseCase(content)
        val output = chapterCompleteUseCaseProvider.renderUserCompletionsUseCase(model)

        return updateCurrentPartReady { currentReady ->
            currentReady.copy(
                contentMode = ContentMode.UserCompletions(
                    model = model,
                    output = output,
                ),
            )
        }
    }

    private fun handleUserCompletionTokenClicked(
        tokenIndex: Int,
    ): BrowseChaptersState {
        val ready = currentPartReadyOrNull() ?: return currentState

        val mode = ready.contentMode as? ContentMode.UserCompletions
            ?: return currentState

        val token = mode.model.tokens.getOrNull(tokenIndex) ?: return currentState
        if (!token.isToggleable) return currentState

        val toggled = chapterCompleteUseCaseProvider.toggleUserBlankUseCase(
            model = mode.model,
            tokenIndex = tokenIndex,
        )

        return updateCurrentPartReady {
            it.copy(
                contentMode = ContentMode.UserCompletions(
                    model = toggled.model,
                    output = toggled.output,
                ),
            )
        }
    }

    private inline fun updateCurrentPartReady(
        crossinline transform: (PartUiState.Ready) -> PartUiState.Ready,
    ): BrowseChaptersState {
        val partIndex = currentState.currentPart
        val ready = currentState.parts[partIndex] as? PartUiState.Ready
            ?: return currentState

        return currentState.copy(
            parts = currentState.parts
                .plus(
                    pair = partIndex to transform(ready),
                )
                .toImmutableMap(),
        )
    }
}
